import { Route } from 'react-router-dom';
import EHRCallback from './components/EHRCallback';
import EPICLaunch from './components/EPICLaunch';
import EHRCommonLaunch from './components/EHRCommonLaunch';

export const getEPICRoutes = () => {
  const pages = [
    {
      path: '/epic/launch/:sessionId',
      Component: EPICLaunch,
    },
  ];

  return pages.map((route, index) => {
    const { path, Component } = route;
    return <Route key={index} path={path} element={<Component />} />;
  });
};

export const getEHRRoutes = () => {
  const pages = [
    {
      path: '/ehr/callback',
      Component: EHRCallback,
    },
  ];

  return pages.map((route, index) => {
    const { path, Component } = route;
    return <Route key={index} path={path} element={<Component />} />;
  });
};

const Wrapper = () => {
  return <EHRCommonLaunch />;
};

export const getEHRLaunchRoutes = () => {
  const pages = [
    {
      path: '/ehr/:ehrProvider/launch',
      Component: Wrapper,
    },
  ];

  return pages.map((route, index) => {
    const { path, Component } = route;
    return <Route key={index} path={path} element={<Component />} />;
  });
};
